import React, { FunctionComponent } from "react"
import { ApproveAudio } from "./ApproveAudio"
import { PromptText } from "./PromptText"
import { useManualPageContext, ManualPageProvider } from "./useManualPageContext"
import { RecordingAffects } from "./RecordingAffects"
import { DownloadAudio } from "./DownloadAudio"
import {
    Stepper,
    StepContent,
    StepLabel,
    Step,
    Typography,
    CircularProgress
} from "@material-ui/core"
import { Title } from "../../components/Title"
import LoadingSpinnerStyles from "../../common/LoadingSpinner.module.scss"

interface Step {
    component: JSX.Element
    name: string
}

export const ManualPage: FunctionComponent = () => {
    return (
        <ManualPageProvider>
            <BaseManualPage />
        </ManualPageProvider>
    )
}
export const BaseManualPage: FunctionComponent = () => {
    const { pageLoading, state } = useManualPageContext()
    const steps: Step[] = [
        {
            component: <PromptText />,
            name: "Prompt Text"
        },
        {
            component: <RecordingAffects />,
            name: "Recording Affect Options"
        },
        {
            component: <ApproveAudio />,
            name: "Review"
        },
        {
            component: <DownloadAudio />,
            name: "Approve"
        }
    ]

    return (
        <div>
            <Title text={"Single"} />
            {pageLoading ? (
                <div className={LoadingSpinnerStyles.LoadingSpinner__absolute__center}>
                    <CircularProgress
                        data-testid="manualPageLoadingSpinner"
                        id="manualPageLoadingSpinner"
                    />
                </div>
            ) : (
                <Stepper activeStep={state.activeStep} orientation="vertical">
                    {steps.map(functionComponent => (
                        <Step key={functionComponent.name}>
                            <StepLabel>
                                <Typography>{functionComponent.name}</Typography>
                            </StepLabel>
                            <StepContent>{functionComponent.component}</StepContent>
                        </Step>
                    ))}
                </Stepper>
            )}
        </div>
    )
}
